<template>
  <grants-index />
</template>
<script setup lang="ts">
import GrantsIndex from '~/components/templates/GrantsIndex.vue';
import { definePageMeta, useAsyncData, usePagesStore, useRoute } from '#imports';
import { DEFAULT_LAYOUT } from '~/constants/layout';

const route = useRoute();
const pages = usePagesStore();

const { data: page } = await useAsyncData(
  route.path,
  async () => {
    return await pages.getPage(route.path);
  },
  {
    watch: [route],
  }
);

pages.setPage(route.path, page.value);

definePageMeta({
  layout: DEFAULT_LAYOUT,
});
</script>
